

type Props = {}

const LoadingFullScreen = (props: Props) => {
    return (
        <div style={{ display: "grid", placeItems: 'center', width: '100%', height: '100vh' }}>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </div>
    )
}

export default LoadingFullScreen